/**
 * STORKKK - Minimalist Product Recommendations Component
 * Leverages Native Custom Elements + Intersection Observer + Section Rendering API
 */

if (!customElements.get('storkkk-product-recommendations')) {
  customElements.define(
    'storkkk-product-recommendations',
    class StorkkkProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.unobserve(this);
              this.loadRecommendations();
            }
          });
        }, { rootMargin: '0px 0px 400px 0px' }); // Pre-fetches 400px before scrolling into view

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      loadRecommendations() {
        const url = this.dataset.url;
        if (!url) return;

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
            const recommendationsElement = parsedHTML.querySelector('storkkk-product-recommendations');

            if (recommendationsElement && recommendationsElement.innerHTML.trim().length > 0) {
              this.innerHTML = recommendationsElement.innerHTML;
            }
          })
          .catch((error) => {
            console.error('STORKKK Recommendations Error:', error);
          });
      }
    }
  );
}